<template>
  <div>
   <el-row style="margin-bottom:10px;">
     <el-button v-if="addOpportunityBusinessCheckImage"
       @click=" $form('addOpportunityBusinessCheckImage')"
       size='small'
       type="primary"
       style="float:right"
       icon='el-icon-circle-plus'
     >添加填写项约束
     </el-button>
   </el-row>

   <mytable
     :tableColums='tableColums_getOpportunityBusinessCheckImageList'
     api='getOpportunityBusinessCheckImageList'
     xupdateapi='updateOpportunityBusinessCheckImage'
     :height="H-165" >
   </mytable>

   <myform
     :viewobj='{
       addOpportunityBusinessCheckImage:    [ "新增填写项约束", "el-icon-circle-plus" ],
       updateOpportunityBusinessCheckImage: [ "修改填写项约束", "el-icon-edit-outline"],
       $succeed$: getOpportunityBusinessCheckImageList
     }'
     @close='$form("addOpportunityBusinessCheckImage","reset")'
     @confirm='myform' >
     <hide slot='obciId' />
     <hide slot='projectId' />
     <hide slot='obciKeyLabel' />
     <template v-slot:oiType="{Myformdata}" >
       <el-select v-model='Myformdata.oiType' clearable >
            <el-option
               v-for="item in obcKeyArray"
               :key="item.key"
               :label="item.label"
               :value="item.key">
           </el-option>
       </el-select>
     </template>
     <template v-slot:obciNecessary="{Myformdata}" >
        <el-radio v-model="Myformdata.obciNecessary" :label="obcKeyOne">是</el-radio>
        <el-radio v-model="Myformdata.obciNecessary" :label="obcKeyTwo">否</el-radio>
     </template>
   </myform>
  </div>
</template>

<script>
  export default {
    data(){
      return {
          theProjectId: "",
          obcKeyOne:1,
          obcKeyTwo:2,
          obcKeyArray:[
            {key:1,label:"法人身份证"},
            {key:2,label:"营业执照"},
            {key:3,label:"合同照片"},
            {key:4,label:"签约合影"},
            {key:5,label:"系统截图"},
          ],

          tableColums_getOpportunityBusinessCheckImageList: {
            $selection: false,

            // oiType: '限制字段key',

            obciKeyLabel: '限制字段名称',

            obciNecessary: ['是否必填',,'@v-if: 1:是, 2:否 '],

            $operation: [
              '操作', 200,
              this.updateOpportunityBusinessCheckImage && `@text: 编辑#success
               @click: $form("updateOpportunityBusinessCheckImage",$row)
              `,
              this.deleteOpportunityBusinessCheckImage && `@text: 删除#danger
               @click: _confirm('确定要删除该填写项约束吗?')
                       .trigger('deleteOpportunityBusinessCheckImage',{obciId:$row.obciId})
                       .trigger('getOpportunityBusinessCheckImageList')
              `,
            ],

          },
      }
    },

    methods:{
         myform(submit, Myformdata) {
            Myformdata.projectId = this.theProjectId;
            var oiType = Myformdata.oiType;
            this.obcKeyArray.forEach(element => {
              if(element.key==oiType){
                Myformdata.obciKeyLabel=element.label;
              }
            });
            submit();
        },
    },
    created() {
      this.theProjectId=A.local('$projectId');
      this.getOpportunityBusinessCheckImageList({projectId:this.theProjectId});
    }
  }
</script>

<style scoped="scoped">
</style>



// WEBPACK FOOTER //
// src/views/bussiness/OrderPictureConstraints.vue